import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RippleInitializer from './RippleInitializer';

const BackButton = ({ children, style, onClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Function to handle the back button click
  const handleBackClick = () => {
    if (onClick) {
      onClick();
    } else {
      window.history.back();
    }
  };

  // Determine the class based on the current page
  const buttonClass = location.pathname === '/journey' || '/Groomsquad' ? 'whiteripple' : 'buttonripple';

  return (
    <button
      onClick={handleBackClick}
      className={buttonClass} // Apply dynamic class
      style={{
        ...style,
        background: 'none',
        border: 'none',
        padding: "0px",
        width: "100%",
        zIndex: "99999",
        position: "relative"
      }}
    >
      {children}
      <RippleInitializer />
    </button>
  );
};

export default BackButton;
